import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import './BreadCrumb.scss';
import classNames from 'classnames';
import ActionLink from '../ActionLink/ActionLink';

function BreadCrumb({ breadCrumb, className }) {
  if (!breadCrumb) {
    return null;
  }

  return (
    <div
      className={classNames('d-flex align-items-center breadcrumb', className)}
    >
      {breadCrumb.map((item, index) => {
        if (index === breadCrumb.length - 1) {
          return <span className="gray-1">{item.label}</span>;
        } else {
          if (item.link) {
            return (
              <>
                <Link to={item.link}>{item.label}</Link>
                <span className="mx-2 av-blue">/</span>
              </>
            );
          } else {
            return (
              <>
                <ActionLink
                  label={item.label}
                  linkClassName="av-blue"
                  iconType="averPointIcon"
                  iconName={item.icon}
                  onClick={item.onClick}
                />
                <span className="mx-2 av-blue">/</span>
              </>
            );
          }
        }
      })}
    </div>
  );
}

export default withRouter(
  connect(
    function mapStateToProps() {
      return {};
    },
    function mapDispatchToProps() {},
  )(BreadCrumb),
);
